var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./icons_list.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-70aa690c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./icons_list.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/view/sharer/activity/icons_list.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] icons_list.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70aa690c", Component.options)
  } else {
    hotAPI.reload("data-v-70aa690c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/sharer/activity/icons_list.vue
// module id = 2324
// module chunks = 0